<template>
  <div>
    <div style="margin-left: 250px;">
       <el-card>
        <el-card style="margin-bottom: 30px;">课消详情（学生统计） <i style="position: absolute;right: 60px;font-size: 25px;color: #409EFF;"
           class="el-icon-circle-close" @click="handleReturn"></i></el-card>

        <el-form style="display: flex;flex-wrap: wrap;">


              <el-form-item label="课程:" style="display: flex;width: 33%;">
                <el-select
                  placeholder="请选择课程"
                  v-model="curriculum"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in curriculumArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.categoryName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="教师姓名:" label-width="100px" style="width: 33%;">
                <el-select
                  placeholder="请选择"
                  v-model="teacherName"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in teacherArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>



              <el-form-item label="学生类型:" label-width="100px" style="width: 33%;">
                <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable multiple>
                  <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
                </el-select>
              </el-form-item>


              <!-- <el-form-item label="线下学员:" style="display: flex;width: 33%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="规划学员:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择学员"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="日期:" label-width="100px" style="width: 40%;">
                <el-date-picker
                style="width: 100%;"
                v-model="dateTimeList"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
                </el-date-picker>
              </el-form-item>

       </el-form>

       <div style="margin-bottom: 20px; text-align: start; width: 30%;">
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课总课时:{{ findStudentHour.schoolSumHour }}</div>
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课消耗课时:{{ findStudentHour.schoolConsumeHour }}</div>
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课剩余课时:{{ findStudentHour.schoolResidueHour }}</div>
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育总课时:{{ findStudentHour.familySumHour }}</div>
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育消耗课时:{{ findStudentHour.familyConsumeHour }}</div>
            <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育剩余课时:{{ findStudentHour.familyResidueHour }}</div>
        </div>


       <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
          <el-button type="primary" size="small" class="btns" icon="el-icon-refresh-right" @click="computeSayss">伴读同步计算</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-refresh" @click="computeSaysss">伴读同步撤销</el-button>

          <span style="width: 30px"></span>
          <span style="width: 30px"></span>

          <el-button type="primary" size="small" class="btns" icon="el-icon-refresh-right" @click="computeSays">同步撤销</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-refresh" @click="computeSay">同步计算</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
       </div>


      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"
            :cell-style="{'text-align':'center'}"
            :data="dataList" border height="700">
        <el-table-column prop="teacherName" label="教师姓名"></el-table-column>
        <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseStartTime" label="开始时间"></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间"></el-table-column>
        <el-table-column prop="subjectName" label="课程"></el-table-column>
        <el-table-column prop="salesNum" label="课消次数"></el-table-column>
        <el-table-column prop="salesMoney" label="课消金额"></el-table-column>


        <el-table-column prop="productClassType" label="班型">
           <template slot-scope="scope">
              <span>{{ scope.row.productClassType === 1 ? "1V1" : scope.row.productClassType === 1 ? "1v2" : scope.row.productClassType === 3 ? '1v3' : '' }}</span>
           </template>
        </el-table-column>
        <el-table-column prop="classPersonType" label="上课人员">
          <template slot-scope="scope">
            <span v-if="scope.row.classPersonType === 1">孩子</span>
            <span v-if="scope.row.classPersonType === 2">孩子和父亲</span>
            <span v-if="scope.row.classPersonType === 3">孩子和母亲</span>
            <span v-if="scope.row.classPersonType === 4">父亲</span>
            <span v-if="scope.row.classPersonType === 5">母亲</span>
            <span v-if="scope.row.classPersonType === 6">父亲和母亲</span>
            <span v-if="scope.row.classPersonType === 7">孩子、父亲、母亲</span>
          </template>
        </el-table-column>
        <el-table-column prop="deductibleProducts" label="课程类别"></el-table-column>
        <el-table-column prop="feeProduct" label="扣费产品"></el-table-column>
      </el-table>



      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>


     </el-card>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

import { ExportExcel, ExportApiExcel } from "../../utils/Export"



import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../../pinia/stores.js'
import { storeToRefs } from 'pinia';

import { Loading } from 'element-ui';

import {
  getTeachers_s,
  getStudents
} from "@/api/firstClassApi";
import {  getStudentsType } from "@/api/fiveClassApi"
export default defineComponent({
  props: {
    DetailsRow: Object,
    TimeList: Array,
    isNewClassType: {
      type: String | Number,
      default: ''
    }
  },
  setup(props, { attrs, slots, emit, expose  }){

    let findStudentHour = reactive({
        schoolResidueHour:0,
        schoolConsumeHour:0,
        schoolSumHour:0,
        familySumHour:0,
        familyConsumeHour:0,
        familyResidueHour:0,
    })

    let teacherArr = ref([])

    let requestParameters = reactive({ pageSize: 10,  pageNum: 1, total: 0, })
    let dataList = ref([])
    let curriculumArr = ref([])
    let getStudentsArr = ref([])
    let getStudentsArr_s = ref([])
    let dateTimeList = ref([])
    let TimeList = ref([])
    let student = ref("")
    let student_s = ref("")
    let curriculum = ref("")
    let studentId = ref("")
    let teacherName = ref("")

    let newClassType =  ref('')
    let newClassTypeList = ref([
      {id:1,name:'规划'},
      {id:2,name:'线下'},
      {id:3,name:'纯补课'},
    ])

    const store = useStore()
    // const { teacherName } = storeToRefs(store.row)
    const rowObj = storeToRefs(store.row)

    onMounted(()=>{

      TimeList.value = props.TimeList

      studentId.value = rowObj.studentId.value
      newClassType.value = props.isNewClassType

      axios.post(`${apiBaseUrl}/student/findStudentHour`, { id: studentId.value },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        let data = res.data.data
        findStudentHour.familyConsumeHour = data.familyConsumeHour
        findStudentHour.familyResidueHour = data.familyResidueHour
        findStudentHour.familySumHour = data.familySumHour
        findStudentHour.schoolConsumeHour = data.schoolConsumeHour
        findStudentHour.schoolResidueHour = data.schoolResidueHour
        findStudentHour.schoolSumHour = data.schoolSumHour
      })

      handleSelectAll()

     if(TimeList.value){
        dateTimeList.value = TimeList.value
        let data = {
          pageSize: 10,
          pageNo: 1,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          studentId: studentId.value ? studentId.value : null,
          teacherId: teacherName.value ? teacherName.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
        }

        getListData(data)
     }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          studentId: studentId.value ? studentId.value : null,
          teacherId: teacherName.value ? teacherName.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
        }

        getListData(data)
     }


      getTeachers_s().then((res) => {
          teacherArr.value = res.data
      })

    })


    const handleSelectAll = () =>{

     axios.get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
        curriculumArr.value = response.data.data
     }).catch(error => { console.error(error)})
     getStudentsType(2).then((res) => {  getStudentsArr.value = res.data })
     getStudentsType(1).then((res) => {  getStudentsArr_s.value = res.data })
    }

    const exportBtns = () => {
      // const data = [
      //   ["姓名", "年龄", "职业"],
      //   ["Alice", 28, "Engineer"],
      //   ["Bob", 22, "Designer"]
      // ];
      // ExportExcel(data)

      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }


      let data = {
        categoryId: curriculum.value,
        startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
        endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
        studentId: studentId.value ? studentId.value : null,
        teacherId: teacherName.value ? teacherName.value : null,
        classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
        // teacherId: teacherId.value,
        // studentIds: str,
      }

      const loadingObj =  Loading.service({ lock: true,  text: '课消中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'  })

      axios.post(`${apiBaseUrl}/classSales/excelStuClassSalesInfo`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } }).then(response => {
        if(response.status == 200){
           const blob = new Blob([response.data], { type: "application/vnd.ms-excel",});
           const downloadLink = document.createElement("a");
           downloadLink.href = URL.createObjectURL(blob);
           downloadLink.download = "课消详情统计.xlsx";
           downloadLink.click();
           handleMessage('导出成功', 'success')
           loadingObj.close()
        }else{
           handleMessage('导出失败', 'error')
           loadingObj.close()
        }
      }).catch(error => {
          handleMessage('导出失败', 'error')
           loadingObj.close()
          console.error(error);
        });

    }


    const computeSay = () =>{
      axios.post(`${apiBaseUrl}/student/updateStudentMerge`,{ isHourMerge: 1, id: studentId.value }, {headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
        if(response.data.code == 200){
           handleMessage(response.data.message, 'success')
        }else{
           handleMessage(response.data.message, 'error')
        }

      })
    }

    const computeSays = () =>{
      axios.post(`${apiBaseUrl}/student/updateStudentMerge`,{ isHourMerge: 2, id: studentId.value }, {headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
        if(response.data.code == 200){
           handleMessage(response.data.message, 'success')
        }else{
           handleMessage(response.data.message, 'error')
        }

      })
    }
    const computeSayss = () =>{
      axios.post(`${apiBaseUrl}/student/updateStudentReadingMerge`,{ readingIsHourMerge: 1, id: studentId.value }, {headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
        if(response.data.code == 200){
           handleMessage(response.data.message, 'success')
        }else{
           handleMessage(response.data.message, 'error')
        }

      })
    }

    const computeSaysss = () =>{
      axios.post(`${apiBaseUrl}/student/updateStudentReadingMerge`,{ isHourMerge: 2, id: studentId.value }, {headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
        if(response.data.code == 200){
           handleMessage(response.data.message, 'success')
        }else{
           handleMessage(response.data.message, 'error')
        }

      })
    }

    const searchBtns = () =>{
      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }

      if(dateTimeList.value){
        let data = {
          pageSize: 10,
          pageNo: 1,
          categoryId: curriculum.value,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          // teacherId: teacherId.value,
          teacherId: teacherName.value ? teacherName.value : null,
          studentId: studentId.value ? studentId.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
          // studentIds: str,
        }
        getListData(data)
      }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          categoryId: curriculum.value,
          studentId: studentId.value ? studentId.value : null,
          teacherId: teacherName.value ? teacherName.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
          // teacherId: teacherId.value,
          // studentIds: str,
        }
        getListData(data)
      }
    }

    const clearBtns = () =>{
      dateTimeList.value = []
      curriculum.value = ""
      student.value  = ""
      student_s.value  = ""
      newClassType.value = ""
      teacherName.value = ""
      if(dateTimeList.value){
        let data = {
          pageSize: 10,
          pageNo: 1,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          // teacherId: teacherId.value ? teacherId.value : null,
          teacherId: teacherName.value ? teacherName.value : null,
          studentId: studentId.value ? studentId.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
        }

        getListData(data)
      }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          // teacherId: teacherId.value ? teacherId.value : null,
          studentId: studentId.value ? studentId.value : null,
          teacherId: teacherName.value ? teacherName.value : null,
          classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
        }

        getListData(data)
      }
    }


    const getListData = (data = {
      categoryId: curriculum.value ? curriculum.value : '',
      classTypeList: newClassType.value.length > 0 ? newClassType.value : [],
      startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
      endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
      pageSize: requestParameters.pageSize, pageNo: requestParameters.pageNum, studentId: studentId.value ? studentId.value : null,teacherId: teacherName.value ? teacherName.value : null,}) =>{

      const loadingObj =  Loading.service({ lock: true,  text: '课消中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'  })

      data.categoryInfoIds =  rowObj.courseCategoryIds.value
      data.channelType = rowObj.channelType.value,
        
      axios.post(`${apiBaseUrl}/classSales/queryStuClassSalesInfo`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {

        let list = response.data
        if (list.code == 200) {
              requestParameters.total = list.data.allTotal
              requestParameters.pageNum = list.data.pageIndex
              dataList.value = list.data.classSales
              handleMessage(list.message, 'success')
              loadingObj.close()
          }else{
              handleMessage('课消详情查询失败', 'error')
              loadingObj.close()
        }
        })
        .catch(error => {
          handleMessage(error,'error')
          console.error(error);
          loadingObj.close()
        });
    }

    const handleSizeChange = (pageSize) => {
      requestParameters.pageSize = pageSize;
      getListData();
    }

    const handleCurrentChange  = (newPage) => {
      requestParameters.pageNum = newPage;
      getListData();
    }

    const handleMessage = (message,type) =>{
       $Vue.$message({ message, type, duration: 500 });
    }


    const handleReturn = () =>{
       emit('handleEmitButs', false, 'blast')
    }


    return {
      curriculumArr,
      getStudentsArr,
      getStudentsArr_s,
      dateTimeList,
      curriculum,
      student,
      student_s,
      dataList,
      requestParameters,
      teacherName,
      handleSelectAll,
      exportBtns,
      searchBtns,
      getListData,
      handleSizeChange,
      handleCurrentChange,
      handleMessage,
      handleReturn,
      clearBtns,
      findStudentHour,
      teacherArr,
      computeSay,
      computeSays,

      computeSaysss,
      computeSayss,

      newClassTypeList,
      newClassType,
    }
  },

})

</script>

<style scoped>

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
.el-form-item__label{
  width: 100px;
}

</style>



// WEBPACK FOOTER //
// src/manager/createComponents/CourseSalesStatisticsDetails_s.vue